module.exports = __webpack_public_path__ + "static/media/shelcia.02a624de.svg";